/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-size:24px;line-height:32px;color:#231d19;font-weight:300;margin-top:13px;margin-bottom:23px}app-controls[_ngcontent-%COMP%]{margin-top:24px}voxel-form-field[_ngcontent-%COMP%]  .voxel-form-field__label{color:#56504c;font-family:\"Itau Display\"}"];
export { styles as styles };
